import { i18n } from "@/plugins/i18n"
import advertisingRouter from "@/routes/advertisingRouter"
import stationRouter from "@/routes/stationRouter"
import podcastRouter from "@/routes/podcastRouter"
import analyticsRouter from "@/routes/analyticsRouter"
import subscriptionsRouter from "@/routes/subscriptionsRouter"
import micrositeRouter from "@/routes/micrositeRouter"
import accountFinanceRouter from "@/routes/accountFinanceRouter"
import accountEmbedRouter from "@/routes/accountEmbeddingRouter"

export default [
  {
    path: "/accounts",
    name: "accounts",
    component: () => import("@/views/Accounts/Accounts"),
    meta: {
      pageTitle: "Accounts",
      rule: "owner",
    },
    children: [
      {
        path: "create",
        component: () => import("@/views/Accounts/AccountCreate"),
        name: "account.create",
        props: true,
        meta: {
          pageTitle: i18n.t("route.page_title.account.create"),
          rule: "owner",
        },
      },
      {
        path: ":accountKey",
        component: () => import("@/views/Accounts/Account"),
        props: true,
        meta: {
          pageTitle: "Real Time",
          rule: "owner",
        },
        children: [
          {
            path: "",
            name: "account",
            component: () => import("@/views/Accounts/AccountDashboard.vue"),
            meta: {
              pageTitle: i18n.t("route.page_title.account.dashboard"),
              rule: "owner",
            },
          },
          {
            path: "upgrade",
            component: () => import("@/views/Accounts/AccountUpgrade"),
            name: "account.upgrade",
            props: true,
            meta: {
              pageTitle: "Account upgrade",
              rule: "owner",
            },
          },
          ...advertisingRouter,
          ...stationRouter,
          ...podcastRouter,
          ...micrositeRouter,
          {
            path: "people",
            name: "account.people",
            component: () => import("@/views/Accounts/components/AccountPeople/AccountPeople"),
            meta: {
              pageTitle: i18n.t("route.page_title.account.people"),
              rule: "owner",
            },
          },
          ...analyticsRouter,
          ...subscriptionsRouter,
          ...accountFinanceRouter,
          {
            // Tab shell, like station settings. The General tab keeps the name
            // account.settings on the default child, so existing links and post
            // targets (common/constants/targetPages.js) still land on a leaf route.
            path: "settings",
            component: () => import("@/views/Accounts/AccountSettingsTabs.vue"),
            children: [
              {
                path: "",
                name: "account.settings",
                component: () => import("@/views/Accounts/AccountSettings"),
                meta: {
                  pageTitle: i18n.t("route.page_title.account.settings"),
                  parent: "account-settings",
                  rule: "owner",
                },
              },
              {
                path: "analytics",
                name: "account.settings.analytics",
                component: () => import("@/views/Accounts/AccountSettingsAnalyticsTab.vue"),
                meta: {
                  pageTitle: i18n.t("route.page_title.account.settings"),
                  parent: "account-settings",
                  rule: "owner",
                },
              },
            ],
          },
          ...accountEmbedRouter,
        ],
      },
    ],
  },
]
